import { useMemo } from 'react';
import { EqualityFn } from 'react-redux';
import { useAppDispatch, useAppSelector } from '@STORE/index';

import { attachmentManagementModalSlice, AttachmentManagementModalDispatchParams, AttachmentManagementModalState } from '@REDUCERS';

function createAttachmentManagementModalHook() {
    return function useAttachmentManagementModal(equalityFn?: EqualityFn<AttachmentManagementModalState>) {
        const state = useAppSelector((store) => store.attachmentManagementModal, equalityFn);

        const dispatch = useAppDispatch();

        const actions = useMemo(() => ({
            open: (params: AttachmentManagementModalDispatchParams) => dispatch(attachmentManagementModalSlice.actions.open(params)),
            close: () => dispatch(attachmentManagementModalSlice.actions.close()),
        }), [dispatch]);

        return {
            state,
            actions,
        };
    };
}

export default createAttachmentManagementModalHook(); 